<template>
    <v-container grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-img src="static/contactBg.jpg" max-height="380px"></v-img>
            </v-flex>
            <v-flex xs12 md8>
                <ContactForm/>
            </v-flex>
            <v-flex xs12 md4>
                <CompanyContact/>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import CompanyContact from '@/components/common/CompanyContact'
    import ContactForm from '@/components/contact/ContactForm'

    export default {
        name: "ContactHome",
        components: {
            ContactForm,
            CompanyContact
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/contact/ContactHome.vue